import { Dialog, DialogContent, Grid, Slide, Typography } from "@mui/material";
import React, { forwardRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCityDialog } from "../../../../app/slices/provincesSlice";
import CityHeader from "./home/header";
import CityTable from "./home/table";


const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const City = () => {
  const dispatch = useDispatch();

  const _City = useSelector((state) => state.provinces);

  const handlDialog = () => {
    dispatch(setCityDialog());
  };

  return (
    <Dialog
      open={_City.openCityDialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      onClose={() => {
        handlDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
      maxWidth='md'
      dir="rtl"
    >
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CityHeader />
          </Grid>
          <Grid item xs={12}>
            <CityTable />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default City;
